import { useEffect, useMemo, useState } from 'react';
import isEqual from 'lodash/isEqual';
import { QuizPlayerAttempt } from '@/components/quiz-player';
import { QuizWidgetActivity } from '../types';

export function useQuizHistory(
  data: QuizWidgetActivity[] = [],
  filter: (activities: QuizWidgetActivity[]) => QuizWidgetActivity[]
) {
  const [attempts, setAttempts] = useState<QuizPlayerAttempt[]>([]);

  const register = (score: number, date = new Date()) => {
    setAttempts((v) => [...v, { date, score }]);
  };

  const records = useMemo(() => filter(data), [filter, data]);

  useEffect(() => {
    // combine attempts from all the provided activities
    const loadedAttempts = records.reduce<QuizPlayerAttempt[]>(
      (carry, item) => {
        const activityAttempts =
          item.attempts.map((item) => ({
            date: new Date(item.startTime),
            // score on the backend seems to be 0-100 while it should be 0-1.
            // this conversion will be removed once it's fixed
            score: item.outcome.score ? item.outcome.score / 100 : 0,
          })) || [];

        carry.push(...activityAttempts);
        return carry;
      },
      []
    );

    // To avoid nested components useless re-render
    // we must sync attempt state only if it changes.
    // Without this you'll get a  "Maximum update depth exceeded" error
    if (!isEqual(attempts, loadedAttempts)) {
      console.log('Setting history attempts: ', loadedAttempts);
      setAttempts(loadedAttempts);
    }
    // setAttempts(loadedAttempts);
  }, [records]); // eslint-disable-line

  return { attempts, register };
}
